import { render, staticRenderFns } from "./OutputOutcomes.vue?vue&type=template&id=fc9c8d54"
import script from "./OutputOutcomes.vue?vue&type=script&lang=js"
export * from "./OutputOutcomes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports